import { useTranslation } from "react-i18next";

import { Factory, ShoppingCart, Truck } from "lucide-react";

import type { PlannedOrder } from "@/api/planningRun";
import { cn } from "@/lib/utils";

const FLAVOR = {
  purchased: { icon: ShoppingCart, className: "text-sky-700" },
  manufactured: { icon: Factory, className: "text-teal-700" },
  transferred: { icon: Truck, className: "text-indigo-700" },
};

/** Purchase, manufacture or transfer. */
export function OrderKind({ flavor }: { flavor: string }) {
  const { t } = useTranslation();
  const { icon: Icon, className } = FLAVOR[flavor as keyof typeof FLAVOR];
  return (
    <span className="inline-flex shrink-0 items-center gap-1">
      <Icon className={cn("size-3.5", className)} aria-hidden />
      {t(`sources.flavor.${flavor}`)}
    </span>
  );
}

/** What kind of order, where it comes from, and the open order it is. */
export function OrderSource({ order }: { order: PlannedOrder }) {
  const { t } = useTranslation();
  const from = order.supplierName ?? order.originLocationName;
  return (
    <span className="flex min-w-0 items-center gap-1">
      <OrderKind flavor={order.flavor} />
      <span className="truncate">
        {from && (
          <> · {t("planningReview.from", "from {{name}}", { name: from })}</>
        )}
        {order.sourceExecutionCode && <> · {order.sourceExecutionCode}</>}
      </span>
    </span>
  );
}
